import React, { FC } from 'react';
import { StyledTotalExercisesByLevel } from './Atoms';
import { ListItemActionButton } from 'src/modules/shared/components';
import { useTranslation } from 'react-i18next';
import { ExerciseSeriesInfo } from 'src/config/api/models/Exercise';
import { useTheme } from '@material-ui/core';

type Props = {
  series: ExerciseSeriesInfo;
};

const TotalExercisesByLevel: FC<Props> = ({ series }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <StyledTotalExercisesByLevel>
      <span>{t('trajectory.sections.shared.total')}</span>
      {Object.entries(series.blocksOfLevel).map(([key, value]) =>
        value === 0 ? null : (
          <ListItemActionButton
            key={key}
            colorVariant={
              key === 'Easy'
                ? theme.config.progressColors.bronze.main
                : key === 'Average'
                ? theme.config.progressColors.silver.main
                : theme.config.progressColors.gold.main
            }
            label={value}
          />
        )
      )}
    </StyledTotalExercisesByLevel>
  );
};

export default TotalExercisesByLevel;
